(function(){
  const root = document.getElementById('htb02-nativefinal');
  if (!root) return;

  (function(){
    function suffix(n){return (n%10==1&&n%100!=11)?'st':(n%10==2&&n%100!=12)?'nd':(n%10==3&&n%100!=13)?'rd':'th';}
    function fmt(d){var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];return days[d.getDay()]+' . '+months[d.getMonth()]+' . '+d.getDate()+' '+suffix(d.getDate())+' , '+d.getFullYear()+' | 11:11 am EST';}
    var d=new Date(); d.setDate(d.getDate()-2);
    var txt=fmt(d);
    root.innerHTML=root.innerHTML.replace(/[A-Z][a-z]{2}\s*\.\s*[A-Z][a-z]{2}\s*\.\s*\d{1,2}\s*(?:st|nd|rd|th)\s*,\s*20\d{2}\s*\|\s*11:11\s*am\s*EST/g, txt);
  })();

  const sticky = root.querySelector('.htb02nf-sticky');
  if (!sticky) return;

  const triggerText = 'INTRODUCING THE BELT THAT GAVE ME MY NIGHTS BACK';
  const trigger = Array.from(root.querySelectorAll('h1,h2,h3,h4,h5,h6,div,span,p'))
    .filter(function(el){ return (el.textContent || '').replace(/\s+/g,' ').trim().includes(triggerText); })
    .sort(function(a,b){
      var at=(a.textContent||'').trim().length, bt=(b.textContent||'').trim().length;
      return at-bt;
    })[0] || null;

  sticky.classList.remove('htb02nf-sticky-visible');
  let ticking = false;

  const revealPoint = () => {
    if (!trigger) return Math.min(700, document.documentElement.scrollHeight * 0.25);
    const triggerTop = trigger.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    return Math.max(0, triggerTop - (window.innerHeight * 0.70));
  };

  const update = () => {
    ticking = false;
    const y = window.scrollY || window.pageYOffset || 0;
    const point = revealPoint();
    if (y >= point) sticky.classList.add('htb02nf-sticky-visible');
    else if (y < point - 400) sticky.classList.remove('htb02nf-sticky-visible');
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  update();
})();
